import useScrollTrigger from '@mui/material/useScrollTrigger';

/**
 * Custom hook to handle AppBar scroll trigger logic.
 *
 * @returns {boolean} Whether the scroll threshold has been reached.
 */
const useAppBarScrollTrigger = () => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  return trigger;
};

export default useAppBarScrollTrigger;
